import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@common/hooks';
import { selected } from '@modules/core/selectors/logged-user';

import { capitalize } from 'lodash';
import moment, { Moment } from 'moment';

import { Celebration } from './types';
import Profile from '@common/components/profile';
import LinkWrapper from '@common/components/linkWrapper';
import { useParams } from 'react-router';


type Props = {
  date: Moment;
  celebrations: Celebration[];
  view: 'birthdays' | 'anniversaries';
};

const CelebrationDateGroup: React.FC<Props> = ({ date, celebrations, view }) => {
  const { t } = useTranslation();
  const isToday = date.isSame(moment(), 'date');
  const loggedUser = useAppSelector(selected);

  const dateClassNames = ['BirthdaysList__Date'];
  if (isToday) dateClassNames.push('BirthdaysList__Date--today');
  const { networkId } = useParams<{ networkId: string }>();


  const isDifferentYear = date.year() !== moment().year();
  const dateFormat = isDifferentYear ? 'D MMM YYYY' : 'D MMM';

  return (
    <div>
      <div className="tw-bg-gray-custom-100 tw-text-gray-custom-700 tw-text-sm
        tw-px-4 tw-py-3 tw-uppercase tw-font-semibold tw-tracking-[1px]"
      >
        {capitalize(date.format(dateFormat))}
      </div>
      {celebrations.map((user: Celebration) => (
        <div
          className="tw-flex tw-items-center tw-justify-between tw-mx-[20px] tw-py-[12px]
            tw-border-b tw-border-x-0 tw-border-t-0 tw-border-gray-100 tw-border-solid"
          key={user.id}
        >
          <LinkWrapper
            url={networkId ? `/networks/${networkId}/users/${user.id}/about` : `/admin/users/${user.id}/about`}
            className="hover:tw-text-inherit hover:tw-underline"
          >
            <Profile enablePopover size={40} user={user}>
              {view === 'birthdays' ? null : (
                <p className="tw-text-gray-custom-430 tw-m-0 tw-pt-1">
                  {t('social:anniversary_in_years', { count: user.year })}
                </p>
            )}
            </Profile>
          </LinkWrapper>
          {user.id !== loggedUser.id && isToday && (
            <LinkWrapper
              url={`${!networkId ? '/admin' : ''}/conversations/users/${user.id}`}
              className="tw-bg-blue-light tw-rounded-md tw-p-2 tw-hover:tw-bg-blue-dull"
            >
              <img src="/static/images/chat/paper-plane-2 1.svg?url" alt="Send message" />
            </LinkWrapper>
          )}
        </div>
      ))}
    </div>
  );
};

export default CelebrationDateGroup;
